// Centralised upload configs. Import UPLOAD_CONFIG and access by key: UPLOAD_CONFIG.PDF, UPLOAD_CONFIG.IMAGE, etc.
// Each entry is fully compatible with UploadValidationOptions from uploadValidation.ts.

export type FileUploadConfig = {
  allowedMimeTypes: string[];
  allowedExtensions: string[];
  maxBytes: number;
  accept: string;
  label: string;
};

export const UPLOAD_CONFIG: {
  IMAGE: FileUploadConfig;
  VIDEO: FileUploadConfig;
  PDF: FileUploadConfig;
  PDF_IMAGE: FileUploadConfig;
  CSV: FileUploadConfig;
  MEDIA: FileUploadConfig;
  DOCUMENT: FileUploadConfig;
} = {
  IMAGE: {
    allowedMimeTypes: ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp", "image/heic", "image/heif"],
    allowedExtensions: [".jpg", ".jpeg", ".png", ".gif", ".webp", ".heic", ".heif"],
    maxBytes: 10 * 1024 * 1024,
    accept: ".jpg,.jpeg,.png,.gif,.webp,.heic,.heif",
    label: "images",
  },

  VIDEO: {
    allowedMimeTypes: ["video/mp4", "video/quicktime", "video/webm"],
    allowedExtensions: [".mp4", ".mov", ".webm"],
    maxBytes: 25 * 1024 * 1024,
    accept: ".mp4,.mov,.webm",
    label: "videos",
  },

  PDF: {
    allowedMimeTypes: ["application/pdf"],
    allowedExtensions: [".pdf"],
    maxBytes: 10 * 1024 * 1024,
    accept: ".pdf",
    label: "PDF",
  },

  PDF_IMAGE: {
    allowedMimeTypes: [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/webp",
      "image/heic",
      "image/heif",
    ],
    allowedExtensions: [".pdf", ".jpg", ".jpeg", ".png", ".gif", ".webp", ".heic", ".heif"],
    maxBytes: 10 * 1024 * 1024,
    accept: ".pdf,.jpg,.jpeg,.png,.gif,.webp,.heic,.heif",
    label: "PDF/images",
  },

  CSV: {
    allowedMimeTypes: ["text/csv", "application/csv", "application/vnd.ms-excel"],
    allowedExtensions: [".csv"],
    maxBytes: 10 * 1024 * 1024,
    accept: ".csv",
    label: "CSV",
  },

  MEDIA: {
    allowedMimeTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/webp",
      "image/heic",
      "image/heif",
      "video/mp4",
      "video/quicktime",
      "video/webm",
    ],
    allowedExtensions: [".jpg", ".jpeg", ".png", ".gif", ".webp", ".heic", ".heif", ".mp4", ".mov", ".webm"],
    maxBytes: 25 * 1024 * 1024,
    accept: "image/*,video/*",
    label: "images/videos",
  },

  DOCUMENT: {
    allowedMimeTypes: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/webp",
      "image/heic",
      "image/heif",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ],
    allowedExtensions: [".jpg", ".jpeg", ".png", ".gif", ".webp", ".heic", ".heif", ".pdf", ".doc", ".docx"],
    maxBytes: 10 * 1024 * 1024,
    accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.webp,.heic,.heif",
    label: "PDF/Doc/images",
  },
};
